module.exports = __webpack_public_path__ + "static/media/IMG_6421.27e160a0.JPG";